import { render } from "./SuspendedUsers.vue?vue&type=template&id=4827ad98"
import script from "./SuspendedUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./SuspendedUsers.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/SuspendedUsers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4827ad98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4827ad98', __exports__)) {
    api.reload('4827ad98', __exports__)
  }
  
  module.hot.accept("./SuspendedUsers.vue?vue&type=template&id=4827ad98", () => {
    api.rerender('4827ad98', render)
  })

}


export default __exports__